<script setup>
import { ref, onMounted, defineProps, defineEmits } from "vue";
import { UsersIcon } from "@heroicons/vue/outline";

import { useCookies } from "vue3-cookies";
import { useAuth } from "@websanova/vue-auth/src/v3.js";
import { useAuthStore } from "@/stores";
import { getRoles } from "@/composable/users/getRoles.js";
import { computed } from "vue";
import eventBus from "@/plugins/eventBus";

const emit = defineEmits(["update:modelValue"]);

const props = defineProps({
  modelValue: {
    default: false,
    type: Boolean,
  },
  kintzApp: {
    type: Boolean,
    default: false,
  },
  active: {
    type: Boolean,
    default: false,
  },
});

const authStore = useAuthStore();
const auth = useAuth();
const roles = getRoles();
const isSuperAdmin = roles.isSuperAdmin.value;
const isAccountManager = roles.isAccountManager.value;
const isSpecificManager = roles.isSpecificManager.value;
const isMultiStoreManager = roles.isMultiStoreManager.value;

const { cookies } = useCookies();

const isImpersonating = ref(false);

const kintzApp = computed(() => props.kintzApp);

const openModal = () => {
  localStorage.removeItem("selected_store");
  eventBus.$emit("STORE_SWITCHED", null);
  emit("update:modelValue", true);
};

const stopImpersonating = () => {
  localStorage.removeItem("impersonate_user");
  localStorage.removeItem("impersonate_token");

  const originalUser = localStorage.getItem("original_user");
  const originalToken = localStorage.getItem("original_token");

  if (!originalUser || !originalToken) {
    console.error("Original user or token not found");
    window.location.reload();
    return;
  }

  const user = JSON.parse(originalUser);
  const token = JSON.parse(originalToken);

  localStorage.removeItem("original_user");
  localStorage.removeItem("original_token");

  cookies.set("default_auth_token", token);
  cookies.set("default_auth_user", user.id);
  auth.user(user);
  auth.token(null, token, false);
  authStore.$patch({
    user: user,
    token: token,
  });

  window.location.reload();
};

onMounted(() => {
  if (localStorage.getItem("impersonate_user")) {
    isImpersonating.value = true;
  }
});
</script>
<template>
  <div>
    <span
      v-if="
        !isImpersonating &&
        (isSuperAdmin ||
          isAccountManager ||
          isSpecificManager ||
          isMultiStoreManager)
      "
      class="block px-4 py-2 text-sm hover:cursor-pointer font-medium"
      :class="[
        {
          'bg-untitled-gray-100': active && !kintzApp,
          'text-untitled-gray-700': !active && !kintzApp,
          'bg-kintz-primary-1 text-kintz-primary-2': active && kintzApp,
          'text-kintz-primary-4 hover:bg-kintz-primary-2 bg-kintz-primary-3':
            !active && kintzApp,
        },
      ]"
      @click="openModal"
    >
      <UsersIcon class="mr-1 h-5 w-5 inline" aria-hidden="true" />
      Switch User
    </span>
    <span
      class="block px-4 py-2 text-sm hover:cursor-pointer font-medium"
      :class="[
        {
          'bg-untitled-gray-100': active && !kintzApp,
          'text-untitled-gray-700': !active && !kintzApp,
          'bg-kintz-primary-1 text-kintz-primary-2': active && kintzApp,
          'text-kintz-primary-4 hover:bg-kintz-primary-2 bg-kintz-primary-3':
            !active && kintzApp,
        },
      ]"
      v-if="isImpersonating"
      @click="stopImpersonating"
    >
      <UsersIcon class="mr-1 h-5 w-5 inline" aria-hidden="true" />
      Switch Back
    </span>
  </div>
</template>
